module.exports = __webpack_public_path__ + "img/18.6.B.a55fad75.png";